import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=bd3027ac&"
import script from "./AddRole.vue?vue&type=script&lang=js&"
export * from "./AddRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports